export default "__VITE_ASSET__CbNa$xfS__"